import { useEffect, useRef } from 'react';
import { listenFullscreen } from '../../channels/fullscreenChannel';
import { useScreenStore } from '../../stores/useScreenStore';

export function useFullscreenChannel() {

    const pendingFullscreen = useRef(null);
    
    useEffect(() => {

        const handleClick = () => {

            if (pendingFullscreen.current === null) {
                return;
            }

            useScreenStore
                .getState()
                .setFullscreenOn(
                    pendingFullscreen.current,
                    false
                );

            pendingFullscreen.current = null;
        };

        document.addEventListener('click', handleClick);

        const unsubscribe = listenFullscreen((payload) => {
            pendingFullscreen.current = payload.fullscreenOn;
        });

        return () => {

            document.removeEventListener('click', handleClick);

            unsubscribe();

        };

    }, []);

}